import React from 'react';
import { fetchLawyerKeywords } from '../../lawyer.api';

type Props = {
  lawyerId: string;
  children: (k: Array<string>) => React.ReactNode;
};

type State = {
  keywords: Array<string>;
};

export class LawyerKeywordsFetcher extends React.Component<Props, State> {
  state: State = {
    keywords: [],
  };

  async componentDidMount() {
    const keywords = (await fetchLawyerKeywords(this.props.lawyerId)).array;
    this.setState({ keywords });
  }

  render() {
    return this.props.children(this.state.keywords);
  }
}
